export default __webpack_public_path__ + "static/media/me9.16fb841f.gif";